import React from "react";
var __jsx = React.createElement;
import stl from "./Accordion.module.css";
var Accordion = function Accordion(_ref) {
  var isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    headTitle = _ref.headTitle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.head,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("h3", null, headTitle), /*#__PURE__*/React.createElement("svg", {
    className: isOpen ? stl.rotate : "",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8805 9.28957L12.0005 13.1696L8.12047 9.28957C7.73047 8.89957 7.10047 8.89957 6.71047 9.28957C6.32047 9.67957 6.32047 10.3096 6.71047 10.6996L11.3005 15.2896C11.6905 15.6796 12.3205 15.6796 12.7105 15.2896L17.3005 10.6996C17.6905 10.3096 17.6905 9.67957 17.3005 9.28957C16.9105 8.90957 16.2705 8.89957 15.8805 9.28957Z",
    fill: "#484848"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.bodySection, " ").concat(isOpen ? stl.open : "")
  }, children));
};
export default Accordion;